import logo from "../assets/logo-white1.png";



export default function Footer() {
  return (
    <footer className="bg-[#20C997] pt-16 pb-0 relative overflow-hidden">

      {/* ================= MAIN CONTAINER ================= */}
      <div className="max-w-[1180px] mx-auto px-4">

        <div className="flex flex-col md:flex-row gap-6 items-center">

          {/* ================= LEFT LOGO BOX ================= */}
          <div className="bg-[#f2f2f2] rounded-2xl w-full md:w-[450px] h-[350px] flex items-center justify-center">
            <a href="/" className="flex items-center justify-center">
  <img
    src={logo}
    alt="logo"
    className="h-[280px] object-contain cursor-pointer"
  />
</a>
          </div>

          {/* ================= RIGHT CARD ================= */}
          <div className="w-full bg-[#8FD0B8] border border-[#2f7f73] rounded-2xl px-10 py-6">

            {/* TOP GRID */}
            <div className="grid grid-cols-2 gap-16">

              {/* RESOURCES */}
              <div>
                <h4 className="text-[14px] font-semibold tracking-wide text-[#1a1a1a] mb-4">
                  RESOURCES
                </h4>

                <ul className="space-y-2 text-[14px] text-[#2f2f2f]">
                  <li>Investor Relations</li>
                  <li>Market insights</li>
                  <li>Research</li>
                </ul>
              </div>

              {/* COMPANY */}
              <div>
                <h4 className="text-[14px] font-semibold tracking-wide text-[#1a1a1a] mb-4">
                  COMPANY
                </h4>

                <ul className="space-y-2 text-[14px] text-[#2f2f2f]">
                  <li>About Us</li>
                  <li>Our Ventures</li>
                  <li>Learn</li>
                  <li>Careers</li>
                  <li>Contact</li>
                  <li>FAQs</li>
                </ul>
              </div>

            </div>

            {/* DIVIDER */}
            <div className="border-t border-[#6aa999] mt-6 mb-5" />

            {/* BOTTOM ROW */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">

              {/* TEXT */}
              <div className="text-[12px] text-[#2f2f2f] leading-tight">
                <p>© 2026 Yield Ventures. All rights reserved.</p>
                <p>
                  CIN : U70200MH2026PTC466080
                </p>
              </div>

              {/* INPUT */}
              <div className="flex items-center bg-[#e6e6e6] rounded-full px-4 py-2 w-full md:w-[260px]">
                <input
                  type="email"
                  placeholder="your@email.com"
                  className="flex-1 text-[12px] bg-transparent outline-none text-[#333]"
                />

                <button className="bg-[#20C997] text-white rounded-full p-2 ml-2">
                  ➤
                </button>
              </div>

            </div>

          </div>
        </div>
      </div>

      {/* ================= BIG BACKGROUND TEXT ================= */}
      <h1 className="
        text-white font-extrabold
        text-[60px] sm:text-[100px] md:text-[140px]
        leading-none
        mt-10
        text-center
        tracking-wide
      ">
        YIELD VENTURES
      </h1>

    </footer>
  );
}